import React from "react";
import { Accordion, Stack, Text, ThemeIcon } from "@mantine/core";
import { IconTicket } from "@tabler/icons-react";
import QRGenerator from "../../../components/QRGenerator";

type Props = {
    show: boolean;
    webUrl?: string;
    eid: number;
    pid: number;
};

export default function VipParkingSection({ show, webUrl, eid, pid }: Props) {
    if (!show) return null;

    return (
        <Accordion.Item value="vip-parking">
            <Accordion.Control
                icon={
                    <ThemeIcon color="red" variant="light" radius="xl">
                        <IconTicket size={18} />
                    </ThemeIcon>
                }
            >
                VIP Parkering
            </Accordion.Control>

            <Accordion.Panel>
                <Stack gap="sm" align="center">
                    <Text fw={600}>VIP Parkering</Text>

                    <QRGenerator value={`${webUrl}/parkering/${eid}/${pid}`} />

                    <Text size="sm" c="dimmed" ta="center">
                        Scan QR-code VIP parkering
                    </Text>
                </Stack>
            </Accordion.Panel>
        </Accordion.Item>
    );
}